import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../components/ErpTemplate';
import { FaSave, FaTrash, FaPlus } from 'react-icons/fa';
import api from '../../services/api';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { NumericFormat } from 'react-number-format';
import { FinField, FinInput } from '../../components/FinField';
import '../../css/financeiro-parcela-pagar.css';


export default function CadastroEventoOrdemServicoResumo({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const [resumos, setResumos] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);
    const history = useHistory();

    const buscar = () => {
        setIsLoading(true);
        if (id) {
            try {
                api({
                    method: "get",
                    action: '/eventoOrdemServicoResumo/' + id,
                    token: token,
                }).then(response => {
                    const dadosRecebidos = response.data.data;
                    setResumos(dadosRecebidos);
                }).finally(() => { setIsLoading(false); });
            } catch (err) {
                toast.error('Erro ao carregar dados: ' + (err.response?.data?.error ?? err.message));
            }
        } else {
            setIsLoading(false);
        }
    };

    const salvar = () => {

        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);
        let dadosSalvar = { ...resumos };
        const metodo = 'put';
        const acao = `/eventoOrdemServicoResumo/${id}`;

        api({
            method: metodo,
            action: acao,
            token: token,
            data: {
                dados: dadosSalvar,
            }
        })
            .then(() => {
                toast.success('Resumo salvo com sucesso!');
                history.push("/evento?idEvento=" + id);
            })
            .catch((error) => {
                toast.error('Erro ao salvar Resumo: ' + (error.response?.data?.error ?? error.message));
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    useEffect(() => {
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div><h1 className="fin-pp__title">Resumo da Ordem de Serviço</h1></div>
                    <div className="fin-pp__actions">
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--primary"
                            disabled={isSubmitting}
                            onClick={salvar}
                        >
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Salvar</>}
                        </button>
                    </div>
                </div>

                <form onSubmit={e => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__card" style={{ overflow: 'hidden', marginBottom: 16 }}>
                        <div className="fin-pp__tblwrap">
                            <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                                <thead>
                                    <tr>
                                        <th style={{ width: 50 }}></th>
                                        <th>Salas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {resumos.length === 0 ? (
                                        <tr><td colSpan={2} className="fin-pp__empty">Nenhum item adicionado</td></tr>
                                    ) : resumos.map((resumo, index) => (
                                        <tr key={index}>
                                            <td style={{ verticalAlign: 'top', paddingTop: 18 }}>
                                                <button
                                                    type="button"
                                                    className="fin-pp__btn fin-pp__btn--danger fin-pp__btn--sm"
                                                    onClick={() => {
                                                        const novoResumos = [...resumos];
                                                        novoResumos.splice(index, 1);
                                                        setResumos(novoResumos);
                                                    }}
                                                    title="Remover"
                                                >
                                                    <FaTrash size={14} />
                                                </button>
                                            </td>
                                            <td>
                                                <div className="fin-pp__filters" style={{ marginBottom: 8 }}>
                                                    <FinField label="Título">
                                                        <FinInput
                                                            type="text"
                                                            value={resumo.nome}
                                                            onChange={(e) => {
                                                                const novoResumos = [...resumos];
                                                                novoResumos[index].nome = e.target.value;
                                                                setResumos(novoResumos);
                                                            }}
                                                        />
                                                    </FinField>
                                                    <FinField label="Valor">
                                                        <NumericFormat
                                                            className="fin-pp__input"
                                                            style={{ paddingLeft: 14 }}
                                                            value={resumo.valor || ''}
                                                            onValueChange={(values) => {
                                                                const novoResumos = [...resumos];
                                                                novoResumos[index].valor = values.value;
                                                                setResumos(novoResumos);
                                                            }}
                                                            thousandSeparator="."
                                                            decimalSeparator=","
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                        />
                                                    </FinField>
                                                    <FinField label="Imposto">
                                                        <NumericFormat
                                                            className="fin-pp__input"
                                                            style={{ paddingLeft: 14 }}
                                                            value={resumo.imposto || ''}
                                                            onValueChange={(values) => {
                                                                const novoResumos = [...resumos];
                                                                novoResumos[index].imposto = values.value;
                                                                setResumos(novoResumos);
                                                            }}
                                                            thousandSeparator="."
                                                            decimalSeparator=","
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                        />
                                                    </FinField>
                                                    <FinField label="Taxa de Serviço">
                                                        <NumericFormat
                                                            className="fin-pp__input"
                                                            style={{ paddingLeft: 14 }}
                                                            value={resumo.taxaservico || ''}
                                                            onValueChange={(values) => {
                                                                const novoResumos = [...resumos];
                                                                novoResumos[index].taxaservico = values.value;
                                                                setResumos(novoResumos);
                                                            }}
                                                            thousandSeparator="."
                                                            decimalSeparator=","
                                                            decimalScale={2}
                                                            fixedDecimalScale={true}
                                                        />
                                                    </FinField>
                                                    <FinField label="Observação" full>
                                                        <FinInput
                                                            type="text"
                                                            value={resumo.observacao}
                                                            onChange={(e) => {
                                                                const novoResumos = [...resumos];
                                                                novoResumos[index].observacao = e.target.value;
                                                                setResumos(novoResumos);
                                                            }}
                                                        />
                                                    </FinField>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 24 }}>
                        <button
                            type="button"
                            className="fin-pp__btn fin-pp__btn--primary"
                            onClick={() => setResumos([...resumos, {}])}
                        >
                            <FaPlus size={14} /> Adicionar Item
                        </button>
                        <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={isSubmitting}>
                            {isSubmitting ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><FaSave size={16} /> Salvar</>}
                        </button>
                    </div>
                </form>
            </div>
        </ErpTemplate>
    );
}
